
import { SleepDialog } from "@/components/SleepDialog"
import { NapDialog } from "@/components/NapDialog"
import { FeedingDialog } from "@/components/FeedingDialog"

interface ActivityDialogsProps {
  sleepDialogOpen: boolean
  setSleepDialogOpen: (open: boolean) => void
  napDialogOpen: boolean
  setNapDialogOpen: (open: boolean) => void
  feedingDialogOpen: boolean
  setFeedingDialogOpen: (open: boolean) => void
  childId?: string
  onSuccess: () => void
}

export function ActivityDialogs({
  sleepDialogOpen,
  setSleepDialogOpen,
  napDialogOpen,
  setNapDialogOpen,
  feedingDialogOpen,
  setFeedingDialogOpen,
  childId,
  onSuccess
}: ActivityDialogsProps) {
  return (
    <>
      <SleepDialog
        open={sleepDialogOpen}
        onOpenChange={setSleepDialogOpen}
        childId={childId}
        onSuccess={() => {
          console.log('Sleep session added/updated, refreshing metrics');
          onSuccess();
        }}
      />
      <NapDialog
        open={napDialogOpen}
        onOpenChange={setNapDialogOpen}
        onSuccess={() => {
          console.log('Nap session added/updated, refreshing metrics');
          onSuccess();
        }}
      />
      <FeedingDialog
        open={feedingDialogOpen}
        onOpenChange={setFeedingDialogOpen}
        childId={childId}
        onSuccess={() => {
          console.log('Feeding session added/updated, refreshing metrics');
          onSuccess();
        }}
      />
    </>
  )
}
